module.exports = __webpack_public_path__ + "img/c01_buildingtechtemper_Normal_ua.d2d7f63d.webp";